import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import { LogoIcon } from "assets/icons";
import { STORAGE_KEYS } from "constants/appConstant";
import { doRequestQRCode, getQRCode } from "stores/slices/auth";
import StorageHelper from "utils/storeHelper";

import AppButton from "components/button";

import styles from "../styles.module.scss";

const RequestQRCodePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const QRCode = useSelector(getQRCode);
  const authToken = StorageHelper.getCookie(STORAGE_KEYS.verifyToken);

  useEffect(() => {
    if (authToken && authToken !== "null" && authToken !== "undefined") {
      dispatch(doRequestQRCode({ id: authToken }));
    } else {
      navigate("/auth/sign-in");
    }
  }, [authToken]);

  return (
    <div className={styles.requestQRCodeContainer}>
      <div className={styles.requestQRCodeRow}>
        <div className="authLogo">
          <LogoIcon />
        </div>
        <Typography className={styles.requestQRCodeTitle}>
          {t("requestQRCode.requestQRCodeTitle")}
        </Typography>
        <Typography className={styles.requestQRCodeMsg}>
          {t("requestQRCode.requestQRCodeMsg")}
        </Typography>
        <div className={styles.requestQRCodeContent}>
          <img width={200} src={QRCode && QRCode.data} />
        </div>
        <div className={styles.requestQRCodeFooter}>
          <AppButton
            label={t("requestQRCode.nextStepToVerify")}
            color={"primary"}
            type="submit"
            onClick={() => {
              navigate("/auth/verify-two-factor-authentication");
            }}
            className="twoFactorAuthBtn"
          />
        </div>
      </div>
    </div>
  );
};

export default RequestQRCodePage;
